const divCardTimeline = {
  inspected_by: 'Revisado por'
};

export default divCardTimeline;
